import {useEffect} from 'react'
import {useMatch, useNavigate} from 'react-router-dom'

import {getOverviewHref, Routes} from '../routes'
import {getLastPage, setLastPage} from '../utils/lastPage'
import {parseURL} from '../utils/url'

export default function useUpdateLastPage(
  shouldRemember: boolean,
  error: Error | string | null | undefined,
  lastPageKey: string,
  lastPageFallbackURL: string = getOverviewHref({}),
) {
  const navigate = useNavigate()
  const match = useMatch(Routes.BASE)
  const currentUrl = match != null ? match.params['*'] : null
  useEffect(() => {
    if (currentUrl != null && shouldRemember) {
      setLastPage(lastPageKey, currentUrl)
    }
  }, [currentUrl, lastPageKey, shouldRemember])
  useEffect(() => {
    if (currentUrl != null && error != null) {
      const lastPage = getLastPage(lastPageKey)

      if (lastPage != null && parseURL(currentUrl).pathname === parseURL(lastPage).pathname) {
        setLastPage(lastPageKey, null)
        navigate(lastPageFallbackURL)
      }
    }
  }, [currentUrl, error, lastPageFallbackURL, lastPageKey, navigate])
}
